<template>
  <div class="modal-clone-lesson">
    <action-dispatcher action="product/get" :parameters="{ limit: 100 }">
      <snow-select
        id="product-select"
        :options="products"
        label="Selecione o produto"
        v-model="product_id"
      />
    </action-dispatcher>
    <action-dispatcher
      v-if="product_id"
      :key="product_id"
      action="membersModules/get"
      :parameters="{ product_id, commit: false }"
      @success="setModules"
    >
      <snow-select
        id="module-select"
        label="Selecione o módulo"
        class="mt-4"
        v-model="module_id"
        :options="modules"
      />
    </action-dispatcher>
    <action-dispatcher
      v-if="module_id"
      :key="module_id"
      action="membersLessons/get"
      :parameters="{ product_id, module_id }"
      @success="setLessons"
    >
      <snow-select
        id="lesson-select"
        label="Selecione a aula"
        class="mt-4"
        v-model="lesson_id"
        :options="lessons"
      />
    </action-dispatcher>

    <div class="snow-submit-buttons mt-7">
      <snow-button
        size="lg"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        text="Confirmar"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    module: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      product_id: "",
      module_id: "",
      lesson_id: "",
      modules: {},
      lessons: {}
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return this.product_id && this.module_id && this.lesson_id;
    }
  },
  methods: {
    submit() {
      this.loading = true;
      this.$store
        .dispatch("membersLessons/clone", {
          lesson_id: this.lesson_id,
          target_product: this.$route.params.id,
          target_module: this.module
        })
        .then(() => {
          this.$router.go(0);
        })
        .finally(() => {
          this.loading = false;
          this.$message.success("Aula copiada.");
        });
    },
    setModules(v) {
      this.modules = v.data.results;
    },
    setLessons(v) {
      this.lessons = v.data.results;
    }
  },
  watch: {
    product_id() {
      this.module_id = "";
    },
    module_id() {
      this.lesson_id = "";
    }
  }
};
</script>
